import { Judging } from '@vote4dance/judging-schema';
import { DivisionId, FederationId, JudgingSettings, PointsJudgingSettings } from '@vote4dance/judging-types';
import { StreamSource } from "../hooks/streams";

export type JudgingItem = Judging;

type JudgingItemCompanion = {
    getJudgingSettings(judging: JudgingItem): JudgingSettings | PointsJudgingSettings;
}

export const JudgingItem: JudgingItemCompanion = {
    getJudgingSettings(judging: JudgingItem): JudgingSettings | PointsJudgingSettings {
		const settings = judging.judging_settings ? JSON.parse(judging.judging_settings) : {};
		return settings;
	}
}

export function JudgingSource(federation_id: FederationId, division_id?: DivisionId) {
    if(division_id) {
        return new StreamSource<JudgingItem[]>(`/judging/${federation_id}/${division_id}`);
    }
    return new StreamSource<JudgingItem[]>(`/judging/${federation_id}`);
}